import { FaxAccount } from "@/Common/Models/Faxing/FaxAccount";
import { FaxAccountNumber } from "@/Common/Models/Faxing/FaxAccountNumber";
import * as LocalOperations from "@/Common/Operations/operations.local";

interface IFaxAccountNumbersControlProps {
    faxAccounts: Immutable.List<FaxAccount>;
}

class FaxAccountNumbersControl extends React.Component<IFaxAccountNumbersControlProps, never> {
    public render(): JSX.Element {
        if (Immutable.List.isList(this.props.faxAccounts) === true && this.props.faxAccounts.size > 0) {
            return this.renderAccounts();
        }
        else {
            return this.renderAccounts();
        }
    }

    private renderAccounts(): JSX.Element {
        var accountsSize = this.props.faxAccounts.size;
        var marginLeft = "";

        if (accountsSize > 1) {
            marginLeft = "marginleft20";
        }

        return (
            <div>
                <ul className="srfax-accounts-list">
                    {this.props.faxAccounts.map((x: FaxAccount, i: number) => (
                        <li className="srfax-account-title" key={"srfax_account_" + i}>
                            {accountsSize > 1 && (
                                <div style={{ paddingBottom: "2px" }}>{x.ClinicalName}</div>
                            )}
                            <div className={marginLeft}>
                                <ul className="fax-numbers-list">
                                    {x.FaxNumbers.map((p: FaxAccountNumber) => (
                                        <li className="radio no-bottom-margin margin-none-top" key={`fax_number_${p.Id}`}>
                                            <label htmlFor={"fax_number_" + p.Id} onClick={() => this.onFaxNumberSelect(p)}>
                                                <input type="radio" name="fax-number" checked={p.Id === sessionStore.getCurrentEmployee().PreferedFaxAccountNumberId} />
                                                <span>{this.displayFaxNumberFormat(p.FaxNumber)}  ({p.Description}) </span>
                                            </label>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }

    private displayFaxNumberFormat(faxNumber: string): string {
        return faxNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    }

    private onFaxNumberSelect(faxNumber: FaxAccountNumber): void {
        if (typeof faxNumber !== "undefined" && faxNumber !== null) {
            sessionStore.dispatch(
                LocalOperations.Settings.SavePreferedFaxNumber,
                { "faxAccountNumberId": faxNumber.Id }
            );
        }
    }
}

export { FaxAccountNumbersControl };
